import styled from "styled-components/native";
import { ListItem } from "./listItem";

export const ListButtonWrapper = styled(ListItem)`
  flex-direction: row;
  justify-content: flex-end;
`;
